import { lazy } from 'react';

// eslint-disable-next-line import/extensions
const OrgsAddDate = lazy(() => import('./orgs-add-date/OrgsAddDate'));
const roles = localStorage.getItem('user_role');

const InstrumentsConfig = {
  settings: {
    layout: {},
  },
  // auth: authRoles.admin,
  auth: roles ? JSON.parse(roles) : [],
  routes: [
    {
      path: '/lawyer/orgs',
      element: <OrgsAddDate />,
    },
  ],
};

export default InstrumentsConfig;
